import { useState, useRef } from 'react';
// @ts-ignore
import Text from '../../Base/Text/Text';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import styles from './FileUpload.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import { IValidationError } from '../../Form/FormControl';
import { useAppContext } from '../../../Services/AppContext';

interface FileUploadProps {
	onChange?: any;
	onFocus?: any;
	placeholder?: string;
	required?: boolean;
	value?: string;
	className?: string;
	id?: string;
	error?: IValidationError;
	onClick?: () => void;
}

export default function FileUpload(props: FileUploadProps) {
	const {
		onChange,
		onFocus,
		placeholder,
		required = false,
		value,
		className,
		error,
		onClick,
	} = props;
	const [file, setFile] = useState(null);
	const { translation } = useAppContext();

	const handleOnChange = e => {
		const fileUploaded = e.target?.files[0];
		setFile(fileUploaded);
		onChange?.(e);
	};

	const hiddenFileInput = useRef(null);

	const handleFilePick = e => {
		hiddenFileInput.current.click();
	};

	return (
		<div className={styles.wrapper}>
			<div
				className={joinClasses([
					className,
					'form-control',
					styles.fakeInput,
					error && styles.invalid,
				])}
				onClick={handleFilePick}>
				{file && (
					<div className={styles.fileName}>
						{file.name.length > 40
							? file.name.substring(0, 40).concat('...')
							: file.name}
					</div>
				)}
				{!file && (
					<div className={styles.placeholder}>
						{translation['base.fileIsNotPicked']}
					</div>
				)}
				<div className={styles.button}>
					{translation['base.pickFileFromComputer']}
				</div>
			</div>
			<input
				{...props}
				type='file'
				onChange={handleOnChange}
				value={value}
				placeholder={placeholder}
				onFocus={onFocus}
				className={styles.input}
				ref={hiddenFileInput}
				onClick={onClick}
			/>
			{props.error && (
				<div className={styles.errorMessage}>
					<Text tx={props.error.message} inline={true} />
				</div>
			)}
		</div>
	);
}
